import { isEmpty } from "utils";
import VernacManager from "utils/vernacular";

export const qualificationOrdering = {
  LESS_THAN_10: 7,
  TENTH: 6,
  TWELFTH: 5,
  DIPLOMA: 4,
  PURSUING_GRADUATION: 3,
  GRADUATE: 2,
  DOCTORATE: 1,
  POST_GRADUATE: 0
};

export const proficiencyMapping = {
  LESS_THAN_10: "generic_less_than_10th",
  TENTH: "generic_tenth",
  TWELFTH: "generic_twelfth",
  PURSUING_GRADUATION: "generic_pursuing_graduation",
  GRADUATE: "generic_graduate",
  POST_GRADUATE: "generic_post_graduate",
  DOCTORATE: "jd_doctorate",
  DIPLOMA: "generic_diploma"
};

export const noticePeriodMapping = {
  IMMEDIATELY: "Immediately",
  SEVEN_DAYS: "7 Days",
  FIFTEEN_DAYS: "15 Days",
  ONE_MONTH: "1 Month",
  TWO_MONTHS: "2 Months",
  THREE_MONTHS_OR_MORE: "3 or more months"
};

export const genderMapping = {
  MALE: "Male",
  FEMALE: "Female"
};

export const salaryFormatMapping = {
  ANNUAL: "ANNUAL",
  MONTHLY: "MONTHLY"
};

export const experienceMappingAlt = {
  0: "No experience",
  12: "< 1 years",
  36: "1-3 years",
  60: "3-5 years",
  72: "5+ years"
};

export const experienceMapping = {
  0: "profile_no_experience",
  6: "generic_one_six_months",
  12: "generic_six_months_one_year",
  24: "generic_one_two_years",
  36: "generic_two_three_years",
  48: "generic_three_four_years",
  60: "generic_four_five_years",
  72: "generic_five_plus_years"
};

export const faImageMapping = {
  33: "accountant.svg",
  34: "human_resource.svg",
  36: "admin_executive.svg",
  20: "back_office_executive.svg",
  43: "counter_sales.svg",
  37: "customer_care.svg",
  31: "delivery_boy.svg",
  63: "digital_marketing_expert.svg",
  108: "helper.svg",
  139: "it_frontend_backend.svg",
  111: "it_frontend_backend.svg",
  147: "logistics_operation.svg",
  51: "operations_executive.svg",
  40: "packer.svg",
  148: "sales_executive.svg",
  53: "sales_or_bd.svg",
  145: "software_developer.svg",
  109: "software_developer.svg",
  105: "software_testing_qa.svg",
  118: "technician.svg",
  38: "telesales_telemarketing.svg"
};

export const documentTemplate = {
  1: {
    docName: "Driving License",
    docField: "driving_license",
    files: [
      {
        name: "Front side",
        uploadField: "file",
        proofField: "proof",
        vernacKey: "profile_front_side"
      }
    ]
  },
  4: {
    docName: "Aadhaar Card",
    docField: "aadhaar",
    files: [
      {
        name: "Front side",
        uploadField: "file",
        proofField: "proof",
        vernacKey: "profile_front_side"
      },
      {
        name: "Back side",
        uploadField: "back_file",
        proofField: "proof_extra",
        vernacKey: "profile_back_side"
      }
    ]
  },
  5: {
    docName: "Pan Card",
    docField: "pan",
    files: [
      {
        name: "Front side",
        uploadField: "file",
        proofField: "proof",
        vernacKey: "profile_front_side"
      }
    ]
  },
  6: {
    docName: "Voter ID Card",
    docField: "voter_id",
    files: [
      {
        name: "Front side",
        uploadField: "file",
        proofField: "proof",
        vernacKey: "profile_front_side"
      }
    ]
  },
  13: {
    docName: "Bank Account Document",
    docField: "bank_account",
    files: [
      {
        name: "Front side",
        uploadField: "file",
        proofField: "proof",
        vernacKey: "profile_front_side"
      }
    ]
  }
};

export const genderSelectOptions = [
  {
    label: "Male",
    value: "MALE"
  },
  {
    label: "Female",
    value: "FEMALE"
  }
];

export const proficiencySelectOptions = [
  {
    label: "Less than 10th",
    value: "LESS_THAN_10"
  },
  {
    label: "10th",
    value: "TENTH"
  },
  {
    label: "12th",
    value: "TWELFTH"
  },
  {
    label: "Diploma",
    value: "DIPLOMA"
  },
  {
    label: "Pursuing Graduation",
    value: "PURSUING_GRADUATION"
  },
  {
    label: "Graduate",
    value: "GRADUATE"
  },
  {
    label: "Post Graduate",
    value: "POST_GRADUATE"
  }
];

export const noticePeriodSelectOptions = [
  {
    label: "Immediately",
    value: "IMMEDIATELY",
    vernacKey: "generic_immediately"
  },
  {
    label: "7 Days",
    value: "SEVEN_DAYS",
    vernacKey: "generic_seven_days"
  },
  {
    label: "15 Days",
    value: "FIFTEEN_DAYS",
    vernacKey: "generic_fifteen_days"
  },
  {
    label: "1 Month",
    value: "ONE_MONTH",
    vernacKey: "generic_one_month"
  },
  {
    label: "2 Months",
    value: "TWO_MONTHS",
    vernacKey: "generic_two_month"
  },
  {
    label: "3 or more months",
    value: "THREE_MONTHS_OR_MORE",
    vernacKey: "generic_three_or_more_months"
  }
];

export const salaryFormatSelectOptions = [
  {
    text: "Yearly",
    value: "ANNUAL",
    vernacKey: "profile_yearly"
  },
  {
    text: "Monthly",
    value: "MONTHLY",
    vernacKey: "profile_monthly"
  }
];

export const experienceOptions = [
  {
    label: "1-6 months",
    value: "6",
    vernacKey: "generic_one_six_months"
  },
  {
    label: "6 months - 1 year",
    value: "12",
    vernacKey: "generic_six_months_one_year"
  },
  {
    label: "1-2 years",
    value: "24",
    vernacKey: "generic_one_two_years"
  },
  {
    label: "2-3 years",
    value: "36",
    vernacKey: "generic_two_three_years"
  },
  {
    label: "3-4 years",
    value: "48",
    vernacKey: "generic_three_four_years"
  },
  {
    label: "4-5 years",
    value: "60",
    vernacKey: "generic_four_five_years"
  },
  {
    label: "5+ years",
    value: "72",
    vernacKey: "generic_five_plus_years"
  },
  {
    label: "None",
    value: "0",
    vernacKey: "profile_edit_none"
  }
];

export const getTranslatedOptions = (options, keyToReplace) => {
  if (isEmpty(VernacManager.getSelectedLanguage())) return options;


  return options?.map((item) => {
    const finalString = VernacManager.translateString(item.vernacKey);
    const obj = {
      ...item,
      [keyToReplace]: finalString
    };
    delete obj.vernacKey;
    return obj;
  });
};
